import { useDispatch, useSelector } from "react-redux";
import { tabclixActions } from "../store/data-slice";
import FileSaver from "file-saver";


const useActionHook = (props) => {

    const dispatch = useDispatch();
    const user = useSelector((state) => {
      if (props.action.type === "vcfDownload") {
        return state.datareducer.AllData;
      }
      return null;
    });   

    
    return function action() {
       switch (props.action.type) {
         case "locationLink":
           return (window.parent.location.href = props.url);

         case "subcontent":
           return dispatch(tabclixActions.setSubContent({ id: props.id }));

         case "changePage":
           return dispatch(tabclixActions.setCurrentPage(props.idToGenerate));

         case "link":
           return (window.parent.location.href = props.url);

         case "popup":
           return alert("Welcome to Tabclix");

         case "call":
           return window.location.assign(`tel:${props.url}`);

         case "mail":
           return window.location.assign(`mailto:${props.url}`);

         case "linkedinLink":
           return (window.parent.location.href = props.url);

         case "tiktok":
           return (window.parent.location.href = `https://www.tiktok.com/${props.url}`);

         case "vcfDownload":

          return user.map((object, keys) => {
            if(props.action.user === object.id ){
            var file = new Blob(
              [
                `BEGIN:VCARD
VERSION:3.0
N:${object.vCard_lastName};${object.vCard_firstName};;;
FN:${object.vCard_firstName} ${object.vCard_lastName}
TITLE:${object.vCard_title}
URL:${object.vCard_url}
END:VCARD`,
              ],
              { type: "text/vcard;charset=utf-8" }
            );
            let a = document.createElement("a");
            a.download = `${object.vCard_lastName}${object.vCard_firstName}.vcf`;
            a.href = URL.createObjectURL(file);
            var reader = new FileReader();
            if (navigator.userAgent.match("CriOS")) {
              reader.onloadend = (e) => {
                window.open(reader.result);
              };
              reader.readAsDataURL(file);
            } else if (navigator.userAgent.match(/iPad|iPhone|Android/i)) {
              reader.onload = (e) => {
                window.location.href = reader.result;
              };
              reader.readAsDataURL(file);
            } else {
              FileSaver.saveAs(
                file,
                `${object.vCard_firstName}${object.vCard_lastName}.vcf`,
                true
              );
            }
              
            }
       });
      //  console.log(myUser);
          //  return fetch(
          //    "https://tabclixdata.s3.ca-central-1.amazonaws.com/Tomasz+Tarasiewicz.vcf"
          //  ).then((response) => {
          //    response.blob().then((blob) => {
          //      // Creating new object of PDF file
          //      const fileURL = window.URL.createObjectURL(blob);
          //      // Setting various property values
          //      let alink = document.createElement("a");
          //      alink.href = fileURL;
          //      alink.download = "https://tabclixdata.s3.ca-central-1.amazonaws.com/Tomasz+Tarasiewicz.vcf";
          //      alink.click();
          //    });
          //  });
         default:
         // code block
       }
  };
};

export default useActionHook;
